import { TableCell, TableCellProps } from "@mui/material";

interface Props extends TableCellProps {
  children: React.ReactNode;
}
const StickyTableCellHeader = ({ children, ...props }: Props) => {
  return (
    <TableCell
      {...props}
      sx={{ position: "sticky", left: 0, zIndex: 10, ...props.sx }}
    >
      {children}
    </TableCell>
  );
};

export default StickyTableCellHeader;
